(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["race-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('race-editorial')) {
  customElements.define('race-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.raceReady) return;
      this.raceReady = true;
      this.dialog = this.querySelector('dialog');
      this.photos = [...this.querySelectorAll('[data-race-photo]')];
      this.photoIndex = 0;
      this.large = this.querySelector('[data-race-large]');
      this.caption = this.querySelector('[data-race-caption]');
      const showPhoto = index => {
        if (!this.photos.length) return;
        this.photoIndex = (index + this.photos.length) % this.photos.length;
        const photo = this.photos[this.photoIndex];
        this.large.src = photo.dataset.src;
        this.large.alt = photo.dataset.caption;
        this.caption.textContent = photo.dataset.caption + ' · ' + (this.photoIndex + 1) + ' / ' + this.photos.length;
      };
      const openPhoto = index => { showPhoto(index); this.dialog.showModal(); };
      this.photos.forEach((photo, index) => photo.addEventListener('click', () => openPhoto(index)));
      this.querySelector('[data-race-open-first]').addEventListener('click', () => openPhoto(0));
      this.querySelector('[data-race-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-race-prev]').addEventListener('click', () => showPhoto(this.photoIndex - 1));
      this.querySelector('[data-race-next]').addEventListener('click', () => showPhoto(this.photoIndex + 1));
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showPhoto(this.photoIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showPhoto(this.photoIndex + 1); }
      });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["race-event-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('race-editorial')) {
  customElements.define('race-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.raceReady) return;
      this.raceReady = true;
      this.dialog = this.querySelector('dialog');
      this.photos = [...this.querySelectorAll('[data-race-photo]')];
      this.photoIndex = 0;
      this.large = this.querySelector('[data-race-large]');
      this.caption = this.querySelector('[data-race-caption]');
      const showPhoto = index => {
        if (!this.photos.length) return;
        this.photoIndex = (index + this.photos.length) % this.photos.length;
        const photo = this.photos[this.photoIndex];
        this.large.src = photo.dataset.src;
        this.large.alt = photo.dataset.caption;
        this.caption.textContent = photo.dataset.caption + ' · ' + (this.photoIndex + 1) + ' / ' + this.photos.length;
      };
      const openPhoto = index => { showPhoto(index); this.dialog.showModal(); };
      this.photos.forEach((photo, index) => photo.addEventListener('click', () => openPhoto(index)));
      this.querySelector('[data-race-open-first]').addEventListener('click', () => openPhoto(0));
      this.querySelector('[data-race-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-race-prev]').addEventListener('click', () => showPhoto(this.photoIndex - 1));
      this.querySelector('[data-race-next]').addEventListener('click', () => showPhoto(this.photoIndex + 1));
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showPhoto(this.photoIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showPhoto(this.photoIndex + 1); }
      });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["show-event-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('show-editorial')) {
  customElements.define('show-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const photos = [...this.querySelectorAll('[data-show-photo]')];
      const dialog = this.querySelector('dialog');
      const large = this.querySelector('[data-show-large]');
      const caption = this.querySelector('[data-show-caption]');
      let current = 0;
      let opener;
      const render = index => {
        current = (index + photos.length) % photos.length;
        large.src = photos[current].dataset.src;
        large.alt = photos[current].dataset.caption;
        caption.textContent = photos[current].dataset.caption;
      };
      photos.forEach((photo, index) => photo.addEventListener('click', () => {
        opener = photo; render(index); dialog.showModal();
      }));
      this.querySelector('[data-show-close]').addEventListener('click', () => dialog.close());
      this.querySelector('[data-show-prev]').addEventListener('click', () => render(current - 1));
      this.querySelector('[data-show-next]').addEventListener('click', () => render(current + 1));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); render(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); render(current - 1); }
      });
      dialog.addEventListener('close', () => opener?.focus());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teslong-about-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('.tl-about-value-select');
  if (!button) return;
  const grid = button.closest('.tl-about-values-grid');
  if (!grid) return;
  grid.querySelectorAll('.tl-about-value-select').forEach((control) => {
    const selected = control === button;
    control.setAttribute('aria-pressed', String(selected));
    control.closest('.tl-about-value').classList.toggle('tl-about-value--highlight', selected);
  });
});
document.addEventListener('click', (event) => {
  const milestone = event.target.closest('.tl-about-milestone');
  if (!milestone || event.target.closest('.tl-about-source, a')) return;
  const timeline = milestone.closest('.tl-about-timeline');
  timeline.querySelectorAll('.tl-about-milestone').forEach((item) => {
    const selected = item === milestone;
    item.classList.toggle('is-selected', selected);
    item.querySelector('.tl-about-date-button').setAttribute('aria-pressed', String(selected));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-welcome-popup')) {
    customElements.define('tl-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || !this.dialog.showModal) return;
        this.storeKey = 'tl-welcome:' + (this.dataset.campaign || 'v1');
        this.scrollHandler = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.evaluateTrigger();
          });
        };
        this.sectionHandler = e => {
          if (this.dataset.design === 'true' && e.target.contains(this)) this.open();
        };
        this.clickHandler = e => {
          if (e.target.closest('[data-tl-close]')) this.dialog.close();
          if (e.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) this.dialog.close();
          }
        };
        this.addEventListener('click', this.clickHandler);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('tl-welcome-open');
          this.write('dismissed', Date.now());
        });
        document.addEventListener('shopify:section:select', this.sectionHandler);
        const result = this.querySelector('[data-tl-result]');
        const preview = new URLSearchParams(location.search).get('tl_popup');
        if (this.dataset.preview === 'true' && (preview === 'preview' || preview === 'success')) {
          if (preview === 'success') this.showSuccess();
          this.open(true);
          return;
        }
        const returning = new URLSearchParams(location.search).get('tl_welcome') === '1';
        if (returning && result && result.dataset.success === 'true') {
          this.write('subscribed', true);
          this.showSuccess();
          this.open(true);
          return;
        }
        if (returning && result && result.dataset.errors === 'true') {
          this.open(true);
          return;
        }
        if (this.dataset.design === 'true' || this.dataset.enabled !== 'true') return;
        if (this.read('subscribed') || this.readSession()) return;
        const dismissed = Number(this.read('dismissed') || 0);
        if (Date.now() - dismissed < Number(this.dataset.days) * 86400000) return;
        if (matchMedia('(max-width: 640px)').matches && this.dataset.mobile !== 'true') return;
        this.loadHandler = () => {
          this.started = true;
          this.timer = setTimeout(() => {
            this.timeReached = true;
            this.evaluateTrigger();
          }, Math.max(0, Number(this.dataset.delay) * 1000 - performance.now()));
          if (this.dataset.mode !== 'delay') window.addEventListener('scroll', this.scrollHandler, { passive: true });
        };
        this.resumeHandler = this.scrollHandler;
        document.addEventListener('focusout', this.resumeHandler);
        document.addEventListener('visibilitychange', this.resumeHandler);
        document.addEventListener('close', this.resumeHandler, true);
        this.loadHandler();
      }
      read(suffix) {
        try { return JSON.parse(localStorage.getItem(this.storeKey + ':' + suffix)); } catch (_) { return null; }
      }
      write(suffix, value) {
        try { localStorage.setItem(this.storeKey + ':' + suffix, JSON.stringify(value)); } catch (_) {}
      }
      readSession() {
        try { return sessionStorage.getItem(this.storeKey + ':seen'); } catch (_) { return false; }
      }
      evaluateTrigger() {
        if (!this.started || this.hasOpened || document.visibilityState !== 'visible') return;
        const height = document.documentElement.scrollHeight - innerHeight;
        const depthReached = height > 0 && scrollY / height * 100 >= Number(this.dataset.depth);
        const mode = this.dataset.mode;
        const ready = mode === 'delay' ? this.timeReached : mode === 'scroll' ? depthReached : mode === 'either' ? (this.timeReached || depthReached) : (this.timeReached && depthReached);
        if (ready && !document.querySelector('dialog[open]') && !document.activeElement.matches('input,textarea,select,[contenteditable="true"]')) this.open();
      }
      showSuccess() {
        this.querySelector('[data-tl-signup]').hidden = true;
        const success = this.querySelector('[data-tl-success]');
        success.hidden = false;
        this.dialog.setAttribute('aria-labelledby', success.querySelector('h2').id);
        this.dialog.setAttribute('aria-describedby', success.querySelector('p.tl-welcome__description').id);
      }
      open(force) {
        if (this.dialog.open || (this.hasOpened && !force)) return;
        this.hasOpened = true;
        window.removeEventListener('scroll', this.scrollHandler);
        clearTimeout(this.timer);
        const picture = this.querySelector('[data-tl-picture]');
        if (picture && !matchMedia('(max-width: 640px)').matches) {
          this.querySelector('[data-tl-visual]').prepend(picture.content.cloneNode(true));
          picture.remove();
        }
        this.dialog.showModal();
        document.documentElement.classList.add('tl-welcome-open');
        this.write('dismissed', Date.now());
        try { sessionStorage.setItem(this.storeKey + ':seen', '1'); } catch (_) {}
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        window.removeEventListener('scroll', this.scrollHandler);
        window.removeEventListener('load', this.loadHandler);
        document.removeEventListener('shopify:section:select', this.sectionHandler);
        document.removeEventListener('focusout', this.resumeHandler);
        document.removeEventListener('visibilitychange', this.resumeHandler);
        document.removeEventListener('close', this.resumeHandler, true);
        this.removeEventListener('click', this.clickHandler);
        if (this.dialog && this.dialog.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion"] && !Shopify.designMode) return;
  try {
    
  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mobileSwiper = null;
      this.hoverTimer = null;
      this.handleDesktopStepHover = this.handleDesktopStepHover.bind(this);
      this.handleDesktopTriggerClick = this.handleDesktopTriggerClick.bind(this);
      this.handleMobileNavClick = this.handleMobileNavClick.bind(this);
      this.handleMobileSlideChange = this.handleMobileSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        desktopTriggers: this.querySelectorAll('[data-step-trigger]'),
        desktopSteps: this.querySelectorAll('.yg-process-steps-v2-step'),
        desktopMedia: this.querySelectorAll('[data-step-media]'),
        mobileNavButtons: this.querySelectorAll('[data-mobile-nav-button]'),
        mobileSlides: this.querySelectorAll('[data-step-slide]'),
        mobileSwiperElement: this.querySelector('.yg-process-steps-v2-mobile-swiper'),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      this.sectionElements.desktopSteps.forEach((step) => {
        step.addEventListener('mouseenter', this.handleDesktopStepHover);
      });

      this.sectionElements.desktopTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleDesktopTriggerClick);
      });

      this.sectionElements.mobileNavButtons.forEach((button) => {
        button.addEventListener('click', this.handleMobileNavClick);
      });

      window.addEventListener('resize', this.handleResize);
      this.bindMobileSwiper();
      this.updateDesktopContentHeights();
      this.setActiveStep(this.activeIndex, { syncSwiper: false, playMedia: false });
      requestAnimationFrame(() => this.playActiveVideo());
    }

    disconnectedCallback() {
      this.sectionElements.desktopSteps.forEach((step) => {
        step.removeEventListener('mouseenter', this.handleDesktopStepHover);
      });

      this.sectionElements.desktopTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleDesktopTriggerClick);
      });

      this.sectionElements.mobileNavButtons.forEach((button) => {
        button.removeEventListener('click', this.handleMobileNavClick);
      });

      if (this.mobileSwiper?.off) {
        this.mobileSwiper.off('slideChange', this.handleMobileSlideChange);
      }

      window.removeEventListener('resize', this.handleResize);
      if (this.hoverTimer) clearTimeout(this.hoverTimer);
      this.pauseAllVideos();
    }

    bindMobileSwiper(retryCount = 12) {
      const swiper = this.sectionElements.mobileSwiperElement?.swiper;

      if (!swiper) {
        if (retryCount > 0) {
          window.setTimeout(() => this.bindMobileSwiper(retryCount - 1), 120);
        }
        return;
      }

      if (this.mobileSwiper === swiper) {
        return;
      }

      this.mobileSwiper = swiper;
      this.mobileSwiper.on('slideChange', this.handleMobileSlideChange);
    }

    handleDesktopStepHover(event) {
      const index = Number(event.currentTarget.dataset.stepIndex);
      if (index === this.activeIndex) return;

      if (this.hoverTimer) clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout(() => {
        this.setActiveStep(index);
      }, 80);
    }

    handleDesktopTriggerClick(event) {
      const index = Number(event.currentTarget.dataset.stepIndex);
      if (this.hoverTimer) clearTimeout(this.hoverTimer);
      this.setActiveStep(index);
    }

    handleMobileNavClick(event) {
      const index = Number(event.currentTarget.dataset.stepIndex);
      this.setActiveStep(index);
    }

    handleMobileSlideChange() {
      const nextIndex =
        typeof this.mobileSwiper.realIndex === 'number' ? this.mobileSwiper.realIndex : this.mobileSwiper.activeIndex;

      this.setActiveStep(nextIndex, { syncSwiper: false });
    }

    handleResize() {
      this.updateDesktopContentHeights();
    }

    updateDesktopContentHeights() {
      this.querySelectorAll('.yg-process-steps-v2-step-content').forEach((content) => {
        content.style.setProperty('--step-content-height', `${content.scrollHeight}px`);
      });
    }

    setActiveStep(index, options = {}) {
      const stepCount = this.sectionElements.desktopSteps.length || this.sectionElements.mobileSlides.length;

      if (stepCount === 0) {
        return;
      }

      const safeIndex = Math.max(0, Math.min(index, stepCount - 1));
      const syncSwiper = options.syncSwiper !== false;
      const playMedia = options.playMedia !== false;

      this.activeIndex = safeIndex;
      this.updateDesktopContentHeights();

      this.sectionElements.desktopSteps.forEach((step, stepIndex) => {
        const isActive = stepIndex === safeIndex;
        const trigger = step.querySelector('[data-step-trigger]');
        const content = step.querySelector('.yg-process-steps-v2-step-content');

        step.classList.toggle('is-active', isActive);

        if (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (content) {
          content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        }
      });

      this.sectionElements.desktopMedia.forEach((media, mediaIndex) => {
        media.classList.toggle('is-active', mediaIndex === safeIndex);
      });

      this.sectionElements.mobileNavButtons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === safeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (syncSwiper && this.mobileSwiper && window.innerWidth <= 699) {
        const currentIndex =
          typeof this.mobileSwiper.realIndex === 'number' ? this.mobileSwiper.realIndex : this.mobileSwiper.activeIndex;

        if (currentIndex !== safeIndex) {
          this.mobileSwiper.slideTo(safeIndex);
        }
      }

      if (playMedia) {
        this.playActiveVideo();
      }
    }

    pauseAllVideos() {
      this.querySelectorAll('yg-video').forEach((videoElement) => {
        if (typeof videoElement.pauseVideo === 'function') {
          videoElement.pauseVideo();
        }
      });
    }

    playActiveVideo() {
      this.pauseAllVideos();

      let videoElement = null;

      if (window.innerWidth <= 699) {
        videoElement = this.sectionElements.mobileSlides[this.activeIndex]?.querySelector('yg-video');
      } else {
        videoElement = this.sectionElements.desktopMedia[this.activeIndex]?.querySelector('yg-video');
      }

      if (videoElement && typeof videoElement.playVideo === 'function') {
        videoElement.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-accordion')) {
    window.customElements.define('yg-accordion', YGAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-dual-tabs-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGTabs03 extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mediaSwiper = null;
      this.contentSwiper = null;
      this.mountSwipersRetryTimer = null;
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
      this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        tabsTrack: this.querySelector('[data-tabs-track]'),
        tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
        tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
        mediaSwiper: this.querySelector('[data-media-swiper]'),
        contentSwiper: this.querySelector('[data-content-swiper]'),
        contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;

      this.sectionElements.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
      });

      this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
      window.addEventListener('resize', this.handleResize);

      this.mountSwipers();
    }

    disconnectedCallback() {
      this.sectionElements.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
      });

      this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
      window.removeEventListener('resize', this.handleResize);
      this.clearMountSwipersRetry();

      if (this.mediaSwiper) {
        this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
        this.mediaSwiper = null;
      }

      if (this.contentSwiper) {
        this.contentSwiper = null;
      }

      this.initialized = false;
    }

    clearMountSwipersRetry() {
      if (this.mountSwipersRetryTimer) {
        window.clearTimeout(this.mountSwipersRetryTimer);
        this.mountSwipersRetryTimer = null;
      }
    }

    scheduleMountSwipersRetry() {
      if (this.mountSwipersRetryTimer) {
        return;
      }

      this.mountSwipersRetryTimer = window.setTimeout(() => {
        this.mountSwipersRetryTimer = null;
        this.mountSwipers();
      }, 150);
    }

    mountSwipers() {
      const mediaSwiperElement = this.sectionElements.mediaSwiper;
      const contentSwiperElement = this.sectionElements.contentSwiper;

      if (!mediaSwiperElement || !contentSwiperElement) {
        return;
      }

      if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
        this.scheduleMountSwipersRetry();
        return;
      }

      this.clearMountSwipersRetry();

      if (this.mediaSwiper !== mediaSwiperElement.swiper) {
        if (this.mediaSwiper) {
          this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
        }

        this.mediaSwiper = mediaSwiperElement.swiper;
        this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
      }

      if (this.contentSwiper !== contentSwiperElement.swiper) {
        this.contentSwiper = contentSwiperElement.swiper;
      }

      this.mediaSwiper.allowTouchMove = false;
      this.mediaSwiper.params.allowTouchMove = false;
      this.contentSwiper.allowTouchMove = false;
      this.contentSwiper.params.allowTouchMove = false;
      this.contentSwiper.params.autoHeight = true;

      this.setActiveState(this.activeIndex, {
        syncSwiper: true,
        scrollBehavior: 'auto',
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const index = Number(tab.dataset.tabIndex);

      this.setActiveState(index);
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }

      const currentIndex = this.activeIndex;
      const lastIndex = this.sectionElements.tabs.length - 1;
      let nextIndex = currentIndex;

      if (event.key == 'ArrowLeft') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
      } else if (event.key == 'ArrowRight') {
        nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
      } else if (event.key == 'Home') {
        nextIndex = 0;
      } else if (event.key == 'End') {
        nextIndex = lastIndex;
      }

      event.preventDefault();

      const nextTab = this.sectionElements.tabs[nextIndex];
      if (nextTab) {
        nextTab.focus();
      }

      this.setActiveState(nextIndex);
    }

    handleMediaSlideChange() {
      const nextIndex =
        typeof this.mediaSwiper.realIndex === 'number' ? this.mediaSwiper.realIndex : this.mediaSwiper.activeIndex;

      if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
        this.contentSwiper.slideTo(nextIndex);
      }

      this.setActiveState(nextIndex, {
        syncSwiper: false,
      });
    }

    handleResize() {
      this.updateOverflowState();
      this.updateIndicator();

      if (this.isTabsOverflowing()) {
        this.scrollActiveTabIntoView('auto');
      } else if (this.sectionElements.tabsScrollContainer) {
        this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      }

      if (this.contentSwiper) {
        this.contentSwiper.updateAutoHeight(0);
      }
    }

    isTabsOverflowing() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;

      if (!scrollContainer) {
        return false;
      }

      return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
    }

    scrollActiveTabIntoView(behavior = 'smooth') {
      const scrollContainer = this.sectionElements.tabsScrollContainer;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!activeTab || !scrollContainer) {
        return;
      }

      if (this.isTabsOverflowing()) {
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = activeTab.getBoundingClientRect();
        const currentScrollLeft = scrollContainer.scrollLeft;
        const rawScrollLeft =
          currentScrollLeft + (itemRect.left - containerRect.left) - (scrollContainer.clientWidth - itemRect.width) / 2;
        const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
        const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

        if (typeof scrollContainer.scrollTo === 'function') {
          scrollContainer.scrollTo({
            left: nextScrollLeft,
            behavior: behavior,
          });
        } else {
          scrollContainer.scrollLeft = nextScrollLeft;
        }
      }
    }

    updateOverflowState() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;

      if (!scrollContainer) {
        return;
      }

      scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
    }

    updateIndicator() {
      const tabsTrack = this.sectionElements.tabsTrack;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!tabsTrack || !activeTab) {
        return;
      }

      tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
      tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
    }

    pauseAllVideos() {
      this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
        if (typeof videoElement.pauseVideo === 'function') {
          videoElement.pauseVideo();
        }
      });
    }

    playActiveVideo() {
      this.pauseAllVideos();

      const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
      const activeVideo = activeSlide?.querySelector('yg-video');

      if (activeVideo && typeof activeVideo.playVideo === 'function') {
        activeVideo.playVideo();
      }
    }

    setActiveState(index, options = {}) {
      const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
      const syncSwiper = options.syncSwiper !== false;
      const scrollBehavior = options.scrollBehavior || 'smooth';

      this.activeIndex = safeIndex;

      if (!this.mediaSwiper || !this.contentSwiper) {
        this.mountSwipers();
      }

      if (syncSwiper) {
        if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
          this.mediaSwiper.slideTo(safeIndex);
        }

        if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
          this.contentSwiper.slideTo(safeIndex);
        }
      }

      this.sectionElements.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === safeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
      });

      this.updateOverflowState();
      this.updateIndicator();

      if (this.isTabsOverflowing()) {
        this.scrollActiveTabIntoView(scrollBehavior);
      } else if (this.sectionElements.tabsScrollContainer) {
        this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      }

      this.playActiveVideo();

      if (this.contentSwiper) {
        this.contentSwiper.updateAutoHeight(0);
      }
    }
  }

  if (!window.customElements.get('yg-tabs-03')) {
    window.customElements.define('yg-tabs-03', YGTabs03);
  }

  class YGImagesSwiper extends HTMLElement {
    constructor() {
      super();
      this._initialized = false;
      this._observer = null;
    }

    connectedCallback() {
      // 找到当前元素所在的外层 swiper slide
      const outerSlide = this.closest('.swiper-slide');

      // 如果外层 slide 已经是 active 状态，直接初始化
      if (outerSlide && outerSlide.classList.contains('swiper-slide-active')) {
        this._initWhenReady();
        return;
      }

      // 否则，监听外层 slide 的 class 变化，等它变为 active 再初始化
      if (outerSlide) {
        this._observer = new MutationObserver(() => {
          if (outerSlide.classList.contains('swiper-slide-active')) {
            this._initWhenReady();
          }
        });
        this._observer.observe(outerSlide, { attributes: true, attributeFilter: ['class'] });
      }
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    _initWhenReady(attempt = 0) {
      if (this._initialized || attempt > 30) return;

      requestAnimationFrame(() => {
        if (this._initialized) return;
        if (this.offsetWidth > 0) {
          this._initialized = true;
          this.initSwiper();
          // 初始化完成后，断开不再需要的 observer
          if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
          }
        } else {
          this._initWhenReady(attempt + 1);
        }
      });
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') {
        if (!this._swiperLoading && window.YGLoadSwiperWhenVisible) {
          this._swiperLoading = true;
          window.YGLoadSwiperWhenVisible(this).then(() => {
            this._swiperLoading = false;
            this.initSwiper();
          }).catch((error) => {
            this._swiperLoading = false;
            console.error(error);
          });
        }
        return;
      }

      const mainImagesElement = this.querySelector('.yg-main-images');
      const thumbImagesElement = this.querySelector('.yg-thumb-images');

      if (mainImagesElement && thumbImagesElement) {
        const thumbSwiper = new Swiper(thumbImagesElement, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });

        const mainSwiper = new Swiper(mainImagesElement, {
          slidesPerView: 1,
          spaceBetween: 20,
          fadeEffect: { crossFade: true },
          allowTouchMove: false,
          thumbs: { swiper: thumbSwiper },
        });
      }
    }
  }
  if (!window.customElements.get('yg-images-swiper')) {
    window.customElements.define('yg-images-swiper', YGImagesSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-grid-text"] && !Shopify.designMode) return;
  try {
    
  class YGImageGridText extends HTMLElement {
    constructor() {
      super();
      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.content = this.querySelector('[data-collapsible-content]');
      this.toggleButton = this.querySelector('[data-collapsible-toggle]');

      if (!this.content || !this.toggleButton) return;

      this.toggleButton.addEventListener('click', this.handleToggleClick);
      window.addEventListener('resize', this.handleResize);
      this.updateCollapsible();
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.handleToggleClick);
      window.removeEventListener('resize', this.handleResize);
    }

    handleToggleClick() {
      const isExpanded = this.content.classList.toggle('is-expanded');
      this.content.classList.toggle('is-collapsed', !isExpanded);
      this.toggleButton.setAttribute('aria-expanded', String(isExpanded));
      this.toggleButton.textContent = isExpanded ? 'Show less' : 'Show more >';
    }

    handleResize() {
      this.updateCollapsible();
    }

    updateCollapsible() {
      const isMobile = window.matchMedia('(max-width: 699px)').matches;

      if (!isMobile) {
        this.content.classList.remove('is-collapsed', 'is-expanded');
        this.toggleButton.hidden = true;
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.toggleButton.textContent = 'Show more >';
        return;
      }

      const isExpanded = this.content.classList.contains('is-expanded');
      this.content.classList.toggle('is-collapsed', !isExpanded);
      this.toggleButton.hidden = false;

      window.requestAnimationFrame(() => {
        const hasOverflow = this.content.scrollHeight > this.content.clientHeight + 1 || isExpanded;
        this.toggleButton.hidden = !hasOverflow;
      });
    }
  }

  if (!window.customElements.get('yg-image-grid-text')) {
    window.customElements.define('yg-image-grid-text', YGImageGridText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps-v2"] && !Shopify.designMode) return;
  try {
    
  class YGProcessStepsV2 extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mobileSwiper = null;
      this.hoverTimer = null;
      this.handleDesktopStepHover = this.handleDesktopStepHover.bind(this);
      this.handleDesktopTriggerClick = this.handleDesktopTriggerClick.bind(this);
      this.handleMobileSlideChange = this.handleMobileSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleMobileMediaLoad = this.handleMobileMediaLoad.bind(this);
      this.handleWindowLoad = this.handleWindowLoad.bind(this);
      this.edgeOffsetFrames = [];
      this.edgeOffsetTimers = [];
      this.mobileSwiperBindTimer = null;
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        desktopTriggers: this.querySelectorAll('[data-step-trigger]'),
        desktopSteps: this.querySelectorAll('.yg-process-steps-v2-step'),
        desktopMedia: this.querySelectorAll('[data-step-media]'),
        mobileSlides: this.querySelectorAll('[data-step-slide]'),
        mobileSwiperElement: this.querySelector('.yg-process-steps-v2-mobile-swiper'),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      this.sectionElements.desktopSteps.forEach((step) => {
        step.addEventListener('mouseenter', this.handleDesktopStepHover);
      });

      this.sectionElements.desktopTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleDesktopTriggerClick);
      });

      window.addEventListener('resize', this.handleResize);
      window.addEventListener('load', this.handleWindowLoad, { once: true });
      this.bindMobileMediaLoadEvents();
      this.bindMobileSwiper();
      this.updateDesktopContentHeights();
      this.updateMobileContentHeights();
      this.setActiveStep(this.activeIndex, { syncSwiper: false, playMedia: false });
      requestAnimationFrame(() => {
        this.updateMobileContentHeights();
        this.playActiveVideo();
      });
    }

    disconnectedCallback() {
      this.sectionElements.desktopSteps.forEach((step) => {
        step.removeEventListener('mouseenter', this.handleDesktopStepHover);
      });

      this.sectionElements.desktopTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleDesktopTriggerClick);
      });

      if (this.mobileSwiper?.off) {
        this.mobileSwiper.off('slideChange', this.handleMobileSlideChange);
      }

      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }

      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('load', this.handleWindowLoad);
      this.unbindMobileMediaLoadEvents();
      this.clearScheduledEdgeOffsetUpdates();
      this.clearMobileSwiperBindTimer();
      this.pauseAllVideos();
    }

    bindMobileSwiper() {
      const swiper = this.sectionElements.mobileSwiperElement?.swiper;

      if (!swiper) {
        this.clearMobileSwiperBindTimer();
        this.mobileSwiperBindTimer = window.setTimeout(() => this.bindMobileSwiper(), 120);
        return;
      }

      this.clearMobileSwiperBindTimer();

      if (this.mobileSwiper === swiper) {
        this.updateMobileSwiperEdgeOffset();
        this.scheduleMobileSwiperEdgeOffsetUpdates();
        return;
      }

      this.mobileSwiper = swiper;
      this.updateMobileSwiperEdgeOffset();
      this.scheduleMobileSwiperEdgeOffsetUpdates();
      this.mobileSwiper.on('slideChange', this.handleMobileSlideChange);
      this.updateMobileContentHeights();
    }

    clearMobileSwiperBindTimer() {
      if (!this.mobileSwiperBindTimer) {
        return;
      }

      window.clearTimeout(this.mobileSwiperBindTimer);
      this.mobileSwiperBindTimer = null;
    }

    handleDesktopStepHover(event) {
      const index = Number(event.currentTarget.dataset.stepIndex);
      if (index === this.activeIndex) {
        return;
      }

      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }

      this.hoverTimer = setTimeout(() => {
        this.setActiveStep(index);
      }, 80);
    }

    handleDesktopTriggerClick(event) {
      const index = Number(event.currentTarget.dataset.stepIndex);
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      this.setActiveStep(index);
    }

    handleMobileSlideChange() {
      const nextIndex =
        typeof this.mobileSwiper.realIndex === 'number' ? this.mobileSwiper.realIndex : this.mobileSwiper.activeIndex;

      this.setActiveStep(nextIndex, { syncSwiper: false });
    }

    handleResize() {
      this.updateMobileSwiperEdgeOffset();
      this.scheduleMobileSwiperEdgeOffsetUpdates();
      this.updateDesktopContentHeights();
      this.updateMobileContentHeights();
    }

    handleMobileMediaLoad() {
      this.updateMobileContentHeights();
      this.scheduleMobileSwiperEdgeOffsetUpdates();
    }

    handleWindowLoad() {
      this.scheduleMobileSwiperEdgeOffsetUpdates();
    }

    updateMobileSwiperEdgeOffset() {
      if (!this.mobileSwiper) {
        return;
      }

      const edgeOffset = window.innerWidth <= 699 ? 20 : 0;

      this.mobileSwiper.params.slidesOffsetAfter = edgeOffset;
      this.mobileSwiper.originalParams.slidesOffsetAfter = edgeOffset;

      if (this.mobileSwiper.update) {
        this.mobileSwiper.update();
      }

      if (this.mobileSwiper.slideTo && window.innerWidth <= 699) {
        this.mobileSwiper.slideTo(this.mobileSwiper.activeIndex, 0, false);
      }
    }

    scheduleMobileSwiperEdgeOffsetUpdates() {
      this.clearScheduledEdgeOffsetUpdates();

      this.edgeOffsetFrames.push(
        window.requestAnimationFrame(() => {
          this.updateMobileSwiperEdgeOffset();
          this.edgeOffsetFrames.push(window.requestAnimationFrame(() => this.updateMobileSwiperEdgeOffset()));
        })
      );

      [120, 360, 800].forEach((delay) => {
        this.edgeOffsetTimers.push(window.setTimeout(() => this.updateMobileSwiperEdgeOffset(), delay));
      });
    }

    clearScheduledEdgeOffsetUpdates() {
      this.edgeOffsetFrames.forEach((frame) => window.cancelAnimationFrame(frame));
      this.edgeOffsetTimers.forEach((timer) => window.clearTimeout(timer));
      this.edgeOffsetFrames = [];
      this.edgeOffsetTimers = [];
    }

    bindMobileMediaLoadEvents() {
      this.mobileMediaElements = this.querySelectorAll('.yg-process-steps-v2-mobile img, .yg-process-steps-v2-mobile video, .yg-process-steps-v2-mobile iframe');

      this.mobileMediaElements.forEach((element) => {
        element.addEventListener('load', this.handleMobileMediaLoad);
        element.addEventListener('loadedmetadata', this.handleMobileMediaLoad);
      });
    }

    unbindMobileMediaLoadEvents() {
      this.mobileMediaElements?.forEach((element) => {
        element.removeEventListener('load', this.handleMobileMediaLoad);
        element.removeEventListener('loadedmetadata', this.handleMobileMediaLoad);
      });

      this.mobileMediaElements = null;
    }

    updateDesktopContentHeights() {
      this.querySelectorAll('.yg-process-steps-v2-step-collapsed').forEach((collapsed) => {
        collapsed.style.setProperty('--step-collapsed-height', `${collapsed.scrollHeight}px`);
      });

      this.querySelectorAll('.yg-process-steps-v2-step-expanded').forEach((content) => {
        content.style.setProperty('--step-content-height', `${content.scrollHeight}px`);
      });
    }

    updateMobileContentHeights() {
      const contents = this.querySelectorAll('.yg-process-steps-v2-mobile-card-content');

      contents.forEach((content) => {
        content.style.minHeight = '';
      });

      if (window.innerWidth > 699 || contents.length === 0) {
        return;
      }

      let maxHeight = 0;

      contents.forEach((content) => {
        maxHeight = Math.max(maxHeight, content.scrollHeight);
      });

      contents.forEach((content) => {
        content.style.minHeight = `${maxHeight}px`;
      });

      if (this.mobileSwiper?.update) {
        this.mobileSwiper.update();
      }
    }

    setActiveStep(index, options = {}) {
      const stepCount = this.sectionElements.desktopSteps.length || this.sectionElements.mobileSlides.length;

      if (stepCount === 0) {
        return;
      }

      const safeIndex = Math.max(0, Math.min(index, stepCount - 1));
      const syncSwiper = options.syncSwiper !== false;
      const playMedia = options.playMedia !== false;

      this.activeIndex = safeIndex;
      this.updateDesktopContentHeights();

      this.sectionElements.desktopSteps.forEach((step, stepIndex) => {
        const isActive = stepIndex === safeIndex;
        const trigger = step.querySelector('[data-step-trigger]');
        const content = step.querySelector('.yg-process-steps-v2-step-expanded');

        step.classList.toggle('is-active', isActive);

        if (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (content) {
          content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        }
      });

      this.sectionElements.desktopMedia.forEach((media, mediaIndex) => {
        media.classList.toggle('is-active', mediaIndex === safeIndex);
      });

      if (syncSwiper && this.mobileSwiper && window.innerWidth <= 699) {
        const currentIndex =
          typeof this.mobileSwiper.realIndex === 'number' ? this.mobileSwiper.realIndex : this.mobileSwiper.activeIndex;

        if (currentIndex !== safeIndex) {
          this.mobileSwiper.slideTo(safeIndex);
        }
      }

      if (playMedia) {
        this.playActiveVideo();
      }
    }

    pauseAllVideos() {
      this.querySelectorAll('yg-video').forEach((videoElement) => {
        if (typeof videoElement.pauseVideo === 'function') {
          videoElement.pauseVideo();
        }
      });
    }

    playActiveVideo() {
      this.pauseAllVideos();

      let videoElement = null;

      if (window.innerWidth <= 699) {
        videoElement = this.sectionElements.mobileSlides[this.activeIndex]?.querySelector('yg-video');
      } else {
        videoElement = this.sectionElements.desktopMedia[this.activeIndex]?.querySelector('yg-video');
      }

      if (
        videoElement &&
        videoElement.getAttribute('data-autoplay') === 'true' &&
        typeof videoElement.playVideo === 'function'
      ) {
        videoElement.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps-v2')) {
    window.customElements.define('yg-process-steps-v2', YGProcessStepsV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
